
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternPortOff as ObiLightLanternPortOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-port-off.js';
 
 
 

 
 export const ObiLightLanternPortOff = createComponent({
   react: React,
   tagName: 'obi-light-lantern-port-off',
   elementClass: ObiLightLanternPortOffElement,
   events: {
     
   }
  });
 
 